/* import __COLOCATED_TEMPLATE__ from './google-sso.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();